export type RelationStatus = 'couple' | 'married' | 'ex' | 'date';

export interface Relation {
  id: string;
  creator_id?: string;
  user_id?: string;
  target_photo?: string;
  photo?: string;
  target_name?: string;
  name?: string;
  target_phones?: string[];
  phones?: string[];
  target_country?: string;
  country?: string;
  target_city?: string;
  city?: string;
  status: RelationStatus;
  confirmed: boolean;
  rejected: boolean;
  created_at: string;
  updated_at: string;
  certifier_id?: string;
  certifier_name?: string;
  certifier_avatar?: string;
  mirror_relation_id?: string;
  deleted?: boolean;
  deleted_at?: string;
  creator_name?: string;
  creator_avatar?: string;
  is_mirror?: boolean;
  comment?: string;
  can_edit?: boolean;
}

// Fonction utilitaire pour convertir entre les deux formats
export function normalizeRelation(relation: Relation): Relation {
  return {
    id: relation.id,
    creator_id: relation.creator_id || relation.user_id,
    user_id: relation.user_id || relation.creator_id,
    target_photo: relation.target_photo || relation.photo,
    photo: relation.target_photo || relation.photo,
    target_name: relation.target_name || relation.name,
    name: relation.target_name || relation.name,
    target_phones: relation.target_phones || relation.phones,
    phones: relation.target_phones || relation.phones,
    target_country: relation.target_country || relation.country,
    country: relation.target_country || relation.country,
    target_city: relation.target_city || relation.city,
    city: relation.target_city || relation.city,
    status: relation.status,
    confirmed: relation.confirmed,
    rejected: relation.rejected,
    created_at: relation.created_at,
    updated_at: relation.updated_at,
    certifier_id: relation.certifier_id,
    certifier_name: relation.certifier_name,
    certifier_avatar: relation.certifier_avatar,
    mirror_relation_id: relation.mirror_relation_id,
    deleted: relation.deleted || false,
    deleted_at: relation.deleted_at,
    creator_name: relation.creator_name,
    creator_avatar: relation.creator_avatar,
    is_mirror: relation.is_mirror || false,
    comment: relation.comment,
    can_edit: relation.can_edit !== undefined ? relation.can_edit : (!relation.is_mirror)
  };
}